import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface OrderConfirmationInput {
    orderId: string;
}

interface SupplierSummary {
    supplierId: string;
    supplierName: string;
    totalParts: number;
    listPrice: number;
    buyPrice: number;
    marginPct: number;
}

export interface OrderConfirmationResponse {
    roNumber: string;
    potentialTotal: boolean;
    quotesOnly: boolean;
    totalParts: number;
    buyPrice: number;
    marginTotal: number;
    marginPct: number;
    hasFlaggedParts: boolean;
    invalidMessage: string | null;
    scheduledDate: string | null;
    suppliers: Array<SupplierSummary>;
    oeCertificationPopup: boolean;
}

const getOrderConfirmation = async (sessionId: string, orderId: string): Promise<OrderConfirmationResponse> => {
    const { data } = await axios.post(`${API_URL}/order/confirmation`,
        { orderId } as OrderConfirmationInput,
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
    return data;
};

export const useGetOrderConfirmation = (orderId: string, isOpen: boolean) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['order-confirmation', orderId],
        queryFn: () => getOrderConfirmation(sessionContext?.sessionId ?? '', orderId),
        enabled: !!sessionContext?.sessionId && !!orderId && isOpen,
        staleTime: 0,
        gcTime: 0,
        refetchOnMount: 'always',
    });
};
